import { Controller } from "@hotwired/stimulus"

// Toggles each submit target's `disabled` attribute based on whether a
// watched field has a value. Useful when the submit button lives outside
// the form in the DOM (e.g. modal footer), so it can't rely on native
// :invalid styling alone.
//
// Usage:
//   <div data-controller="disable-until-selected">
//     <select data-disable-until-selected-target="field"
//             data-action="change->disable-until-selected#update">…</select>
//     <button form="…" type="submit"
//             data-disable-until-selected-target="submit"
//             disabled>Invite</button>
//   </div>
export default class extends Controller {
  static targets = ["field", "submit"]

  connect() {
    this.update()
  }

  fieldTargetConnected() {
    this.update()
  }

  update() {
    const hasValue = this.hasFieldTarget && Boolean(this.fieldTarget.value)
    this.submitTargets.forEach((btn) => {
      btn.disabled = !hasValue
      btn.setAttribute("aria-disabled", (!hasValue).toString())
    })
  }
}
